import React, { createContext, useReducer, useContext, useEffect } from 'react';
import authReducer from './reducer';
import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

interface AuthContextType {
  state: {
    loading: boolean;
    loggedIn: boolean;
    error: null;
    user: any;
  };
  dispatch: React.Dispatch<any>;
}

const initialState = {
  loading: false,
  loggedIn: false,
  error: null,
  user: null,
};

const AuthContext = createContext<AuthContextType>({
  state: initialState,
  dispatch: () => {},
});

const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(authReducer, initialState) as [AuthContextType['state'], AuthContextType['dispatch']];

  return (
    <AuthContext.Provider value={{ state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => {
  return useContext(AuthContext);
};

const useLogout = () => {
  useContext(AuthContext).dispatch({ type: 'LOGOUT' });
}

export { AuthProvider, AuthContext, useAuth, useLogout };
